import { useState } from "react";
import { useAuth } from "../../auth/AuthProvider";
import { useI18n } from "../../i18n/I18nProvider";
import type { MessageKey } from "../../i18n/messages";

export function GoogleButton({ next }: { next: string }) {
  const { t } = useI18n();
  const { googleEnabled, signInWithGoogle } = useAuth();
  const [error, setError] = useState<MessageKey | null>(null);
  const [busy, setBusy] = useState(false);
  if (!googleEnabled) return null;
  return (
    <>
      <button
        type="button"
        className="btn btn-google btn-block"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          const r = await signInWithGoogle(next);
          if (!r.ok) {
            setError(r.error);
            setBusy(false);
          }
        }}
      >
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.4h6.5a5.5 5.5 0 0 1-2.4 3.6v3h3.9c2.2-2.1 3.5-5.1 3.5-8.7z" />
          <path fill="#34A853" d="M12 24c3.2 0 6-1.1 8-2.9l-3.9-3a7.2 7.2 0 0 1-10.7-3.8h-4v3.1A12 12 0 0 0 12 24z" />
          <path fill="#FBBC05" d="M5.4 14.3a7.2 7.2 0 0 1 0-4.6V6.6h-4a12 12 0 0 0 0 10.8l4-3.1z" />
          <path fill="#EA4335" d="M12 4.8c1.8 0 3.4.6 4.6 1.8l3.4-3.4A12 12 0 0 0 1.4 6.6l4 3.1A7.2 7.2 0 0 1 12 4.8z" />
        </svg>
        {t("auth.google")}
      </button>
      {error && (
        <p className="field-error" role="alert">
          {t(error)}
        </p>
      )}
      <div className="auth-divider">
        <span>{t("auth.or")}</span>
      </div>
    </>
  );
}
